/**
 * Utilitário para atualizar meta tags dinamicamente
 * Útil para Open Graph, Twitter Cards e previews do WhatsApp
 */

interface MetaTagsData {
  title: string;
  description: string;
  image: string;
  url: string;
  type?: string;
}

/**
 * Atualiza ou cria meta tags no head do documento
 */
export const updateMetaTags = (data: MetaTagsData) => {
  const baseUrl = 'https://empregamecanico.com.br';
  const fullUrl = data.url.startsWith('http') ? data.url : `${baseUrl}${data.url}`;
  
  // Função auxiliar para atualizar ou criar meta tag
  const setMetaTag = (property: string, content: string, isProperty = true) => {
    const attribute = isProperty ? 'property' : 'name';
    let meta = document.querySelector(`meta[${attribute}="${property}"]`);
    
    if (!meta) {
      meta = document.createElement('meta');
      meta.setAttribute(attribute, property);
      document.head.appendChild(meta);
    }
    
    meta.setAttribute('content', content);
  };

  // Título da página
  document.title = data.title;

  // Meta tags básicas
  setMetaTag('description', data.description, false);
  
  // Open Graph tags (usado pelo WhatsApp, Facebook, etc)
  setMetaTag('og:title', data.title);
  setMetaTag('og:description', data.description);
  setMetaTag('og:image', data.image);
  setMetaTag('og:url', fullUrl);
  setMetaTag('og:type', data.type || 'website');
  setMetaTag('og:site_name', 'Emprega Mecânico');
  setMetaTag('og:locale', 'pt_BR');
  
  // Twitter Card tags
  setMetaTag('twitter:card', 'summary_large_image');
  setMetaTag('twitter:title', data.title);
  setMetaTag('twitter:description', data.description);
  setMetaTag('twitter:image', data.image);
  setMetaTag('twitter:url', fullUrl);
};

/**
 * Remove meta tags dinâmicas (opcional, para limpar ao sair da página)
 */
export const resetMetaTags = () => {
  const defaultTitle = 'Emprega Mecânico - Conectando Talentos do Setor Automotivo';
  const defaultDescription = 'A primeira plataforma focada em conectar profissionais do setor automotivo às melhores oportunidades de trabalho no Brasil.';
  const defaultImage = 'https://empregamecanico.com.br/assets/images/social-preview.svg';
  const defaultUrl = 'https://empregamecanico.com.br/';

  updateMetaTags({
    title: defaultTitle,
    description: defaultDescription,
    image: defaultImage,
    url: defaultUrl
  });
};

